/*
  Helper function for the use of mapFieldObjects.
*/

import { map } from 'ramda';

import { getLatestFinishedCommitData } from './documentHandling';

const normalize = map(d => ({ ...d, content: getLatestFinishedCommitData(d) }));

export default normalize;
